import { del, get, set } from 'idb-keyval'

function createKv<T>(key: string) {
  const getKv = () => {
    try {
      return get<T>(key)
    } catch (e) {}
  }
  const setKv = (value: T) => {
    try {
      set(key, value)
    } catch (e) {}
  }
  const delKv = () => {
    try {
      del(key)
    } catch (e) {}
  }
  return [getKv, setKv, delKv] as const
}

export const [getDisablePush, setDisablePush, delDisablePush] = createKv<boolean>('disablePush')
